import React from 'react';
import MakeOption from './MakeOption';

const MakeMenu = (props) => {
        return(
            <div>
                <select className="form-control" name={props.name} onChange={props.setMake} >
                    <option value='make'>Make...</option>
                    {props.makeMenu && 
                        typeof props.makeMenu === "object" &&
                        !Array.isArray(props.makeMenu) &&
                        Object.keys(props.makeMenu).map(key => (
                            <MakeOption key={key} value={key} />
                        ))}
                </select>
            </div>
        );
};

export default MakeMenu;